"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForbiddenError = void 0;
const ResponseError_1 = require("./ResponseError");
class ForbiddenError extends ResponseError_1.ResponseError {
    constructor(message = "Forbidden error.") {
        super("Forbidden error.", message, 403);
    }
}
exports.ForbiddenError = ForbiddenError;
//# sourceMappingURL=ForbiddenError.js.map